import React, { useEffect, useState } from 'react';
import bem from '@justpark/helpers/src/bem/bem';
import { useDispatch } from 'react-redux';
import { appleLogin } from '../../stores/auth';
import appleSignInConfig from '../../../config/appleSignIn';

import '../../../static/scss/components/appleSignInButton.scss';

const initialiseApple = () => window.AppleID.auth.init(appleSignInConfig);

const AppleSignInButton = () => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (window.AppleID) {
      initialiseApple();
    }
  }, []);

  useEffect(
    () => {
      const signInSuccessListener = document.addEventListener(
        'AppleIDSignInOnSuccess',
        data => {
          if (!data) {
            return;
          }
          const { id_token: idToken, code } = data.detail.authorization;
          const appleFirstName = data.detail?.user?.name?.firstName;
          const appleLastName = data.detail?.user?.name?.lastName;

          if (appleFirstName && appleLastName) {
            localStorage.setItem('firstName', appleFirstName);
            localStorage.setItem('lastName', appleLastName);

            dispatch(
              appleLogin(idToken, code, appleFirstName, appleLastName, true)
            );
            return;
          }

          const storageFirstName = localStorage.getItem('firstName');
          const storageLastName = localStorage.getItem('lastName');

          const hasUsedStorage = !!storageFirstName || !!storageLastName;

          dispatch(
            appleLogin(
              idToken,
              code,
              storageFirstName,
              storageLastName,
              hasUsedStorage
            )
          );
        }
      );

      return () => {
        document.removeEventListener(
          'AppleIDSignInOnSuccess',
          signInSuccessListener
        );
      };
    },
    [dispatch]
  );

  return (
    <div
      className={bem('c-appleSignin', null, { disabled })}
      data-color="white"
      data-border="true"
      data-border-radius="10"
      data-type="continue"
      id="appleid-signin"
      onClick={() => {
        setDisabled(true);

        setTimeout(() => {
          setDisabled(false);
        }, 300);
      }}
    />
  );
};

export default AppleSignInButton;
